module.exports = __webpack_public_path__ + "e9a2ea77d189d00c4f14067d9204db6e.woff2";